module.exports = __webpack_public_path__ + "static/media/RPV_330.1ec77083.png";